//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        data(){
            return {
                fbCode:'',
                fbMessage:'',
                retryBtn:''
            }
        },
        mounted(){
            //实名认证message有数字次数变化后台返回
            this.fbCode = this.$route.query.code;
            this.fbMessage = this.$route.query.fbMessage;
            this.retryBtn = this.$route.query.retryBtn;
        },
        methods: {
            btnBack(){
                this.$router.push("/index")
            },
            retryInfo(){
                this.$router.go(-1);return false;
            }
        },
        
    }



// WEBPACK FOOTER //
// ./src/view/corpLegalFail.vue